import { FieldClassification } from "@eai-toolkit/client";

import type { FieldRenderer } from "../types";

export type NonEmptyFieldClassification = Exclude<
  FieldClassification,
  typeof FieldClassification.empty
>;

// Type-safe mapping using FieldClassification enum keys
const CLASSIFICATION_METADATA: Record<
  NonEmptyFieldClassification,
  { label: string; tooltip: string }
> = {
  [FieldClassification.servicenow_public]: {
    label: "serviceNow public",
    tooltip: "Public data, freely shareable",
  },
  [FieldClassification.servicenow_internal_confidential]: {
    label: "serviceNow internal confidential",
    tooltip: "Internal use only, basic protection",
  },
  [FieldClassification.servicenow_internal_restricted]: {
    label: "serviceNow internal restricted",
    tooltip: "Internal use only, enhanced protection",
  },
  [FieldClassification.research_only]: {
    label: "research only",
    tooltip: "Research agreements apply, restricted use",
  },
  [FieldClassification.third_party_licensed]: {
    label: "third party licensed",
    tooltip: "External license terms apply",
  },
  [FieldClassification.customer_restricted]: {
    label: "customer restricted",
    tooltip: "Highest protection, legal obligations apply",
  },
};

const renderer: FieldRenderer = (fieldValue: unknown) => {
  if (!fieldValue || typeof fieldValue !== "string") {
    return {
      formattedText: "-",
    };
  }

  const classification = fieldValue as NonEmptyFieldClassification;
  const metadata = CLASSIFICATION_METADATA[classification];

  if (!metadata) {
    return {
      formattedText: fieldValue,
    };
  }

  return {
    formattedText: metadata.label,
  };
};

export default renderer;
export { CLASSIFICATION_METADATA };
